const CellPhoneIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M10.2467 4.09741H13.7533M17 2L7 2C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21072 2.96086 5 3.46957 5 4L5 20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20L19 4C19 3.46957 18.7893 2.96086 18.4142 2.58579C18.0391 2.21072 17.5304 2 17 2ZM16.5828 6.20606L16.5828 19.1221H7.41711L7.41711 6.20606L16.5828 6.20606Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export default CellPhoneIcon;
